import authRules from '../authRules.js';

const addTour = (user) => {
  const { tour } = user.securityLevels;
  if (tour >= authRules.addTour.tour) {
      return true;
  } else {
      return false;
    }
  }


export default addTour;
